"use client";
import React from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { updateBookingStatus } from "../Services/Organisation.service";
import { Box, Button } from "@mui/material";

const CheckoutForm = (props: any) => {
  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = React.useState<any>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    setIsLoading(true);
    const url = new URL(window.location.href);
    const hasQueryParams = url.search.length > 0;
    const separator = hasQueryParams ? '&' : '?';
    let confirmParams = {
      return_url: `${window.location.href}${separator}bookingId=${props.bookingId}&paymentIntentId=${props?.paymentIntentId}`
    };
    if (props.addReturnUrl) {
      const url = new URL(window.location.href);
      const hasQueryParams = url.search.length > 0;
      const separator = hasQueryParams ? '&' : '?';

      // Append the new parameter correctly using the determined separator
      confirmParams = {
        return_url: `${window.location.href}${separator}bookingId=${props.bookingId}&paymentIntentId=${props?.paymentIntentId}`
      };
    }
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams: confirmParams,
      redirect: "if_required"
    });

    if (error) {
      setMessage(error.message);
      setIsLoading(false);
    } else {
      setMessage('Handling payment confirmation...');
      // Check the paymentIntent status
      if (paymentIntent && paymentIntent.status === 'succeeded') {
        await updateBookingStatus({ bookingsalutation: "success", paymentIntentId: paymentIntent?.id }, props.bookingId, props.isLive)
        props.setFieldValue("stripePaymentDetails", null)
        props.setFieldValue("eurostripePaymentDetails", null)
        props.setActiveStep((prev: any) => prev + 1)
      }
      setIsLoading(false);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <form id="payment-form">
        <Box sx={{ marginTop: "0.5rem", marginBottom: "0.5rem" }}>

          <PaymentElement id="payment-element" />
        </Box>
        <div className="buttons">
          <Button disabled={isLoading || !stripe || !elements} id="submit" type="button" onClick={handleSubmit} variant="contained" className="continueButton">
            <span id="button-text">
              {isLoading ? <div className="spinner" id="spinner">Processing</div> : "Pay now"}
            </span>
          </Button>
        </div>
        {message && <div id="payment-message">{message}</div>}
      </form>
    </div>
  );
};

export default CheckoutForm